export interface UpdateBibliographyNewArrivalMagazineRequest {
  isPublish: boolean
  ids: number[]
}

export function UpdateBibliographyNewArrivalMagazineRequestToJSON(
  value: UpdateBibliographyNewArrivalMagazineRequest
): any {
  return {
    is_publish: value.isPublish ?? undefined,
    ids: value.ids.length > 0 ? value.ids : undefined
  }
}
